<template>
<v-row>
  <v-col cols="12">
    <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
      <v-form autocomplete="off" id="createTicket">
        <v-card>
          <v-card-title class="headline">Create Ticket</v-card-title>
          <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <ValidationProvider name="Title" rules="required|max:150" v-slot="{ errors }">
                      <v-text-field label="Title*" :error-messages="errors" class="otpFields" type="text" v-model="ticket.title"></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider name="Description" rules="max:500" v-slot="{ errors }">
                      <v-textarea label="Description" :error-messages="errors" class="otpFields" type="text" v-model="ticket.description"></v-textarea>
                    </ValidationProvider>
                  </v-col>
                </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="text" :disabled="loading" @click="$emit('closeDialog')">Cancel</v-btn>
            <v-btn color="primary" class="black--text" type="submit" :loading="loading" :disabled="loading" @click="handleSubmit(createTicket())">Send</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </ValidationObserver>
  </v-col>
</v-row>
</template>

<script>
export default {
name: "OpenTicket",
  props: {
    appointmentId: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      snackbarShow: false,
      ticket: {
        title: '',
        description: ''
      },
      loading: false,
    }
  },
  methods: {
    createTicket() {
      this.loading = true
      let request = {
        title: this.ticket.title,
        description: this.ticket.description,
        appointment_id: this.appointmentId ? this.appointmentId : null,
      }
      this.axios.post(`${process.env.VUE_APP_API_URL}/api/tickets`, request)
          .then((response) => {
            if (response.data.status === 1) {
              this.$emit('closeDialog', true)
            }
          }).catch((error) => {
        console.log(error);
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted() {}
}
</script>
